// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const forretress: PokeData = {
  "id": 205,
  "name": "forretress",
  "height": 12,
  "weight": 1258,
  "base_experience": 163,
  "types": [
    PokeType.BUG,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "reflect",
    "bide",
    "self-destruct",
    "explosion",
    "curse",
    "protect",
    "spikes",
    "zap-cannon",
    "rollout",
    "rapid-spin",
    "iron-defense",
    "gyro-ball",
    "natural-gift",
    "payback",
    "toxic-spikes",
    "magnet-rise",
    "mirror-shot",
    "bug-bite",
    "autotomize",
    "heavy-slam"
  ],
  "moves": [
    "tackle",
    "reflect",
    "curse",
    "protect",
    "zap-cannon",
    "toxic-spikes",
    "bug-bite",
    "lunge",
    "meteor-mash",
    "metal-burst",
    "gear-up",
    "pounce",
    "heal-order"
  ],
  "evolution_chain": {
    "id": 102,
    "item": null,
    "species": [
      {
        "name": "pineco",
        "order": 235,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "forretress",
        "order": 236,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 204,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 161,
    "speed": 74,
    "ability_power": 166
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
